import { render } from "./VisionneuseVideos.vue?vue&type=template&id=f8a35c0e&scoped=true"
import script from "./VisionneuseVideos.vue?vue&type=script&lang=js"
export * from "./VisionneuseVideos.vue?vue&type=script&lang=js"

import "./VisionneuseVideos.vue?vue&type=style&index=0&id=f8a35c0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8a35c0e"]])

export default __exports__